import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "../components/ui/spinner";

const MicrosoftCallbackPage = () => {
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleMicrosoftCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get("code");
        // const state = params.get("state");
        const error = params.get("error");

        if (error) {
          throw new Error(`Microsoft認証エラー: ${error}`);
        }

        if (!code) {
          throw new Error("認証コードが不足しています");
        }

        // サーバーサイドでの処理のため、直接リダイレクト
        const callbackUrl = `/api/auth/microsoft/callback${location.search}`;
        window.location.href = callbackUrl;
        
      } catch (err) {
        console.error("Microsoft callback error:", err);
        setError(err.message || "Microsoft認証処理に失敗しました");
        
        // エラーが発生した場合、3秒後にログインページにリダイレクト
        setTimeout(() => {
          navigate("/login?error=" + encodeURIComponent(err.message));
        }, 3000);
      }
    };

    handleMicrosoftCallback();
  }, [location, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 flex items-center justify-center p-4">
        <div className="text-center text-white">
          <div className="mb-4">
            <svg className="w-16 h-16 mx-auto text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-2">認証エラー</h2>
          <p className="text-lg mb-4">{error}</p>
          <p className="text-sm opacity-75">3秒後にログインページにリダイレクトします...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 flex items-center justify-center p-4">
      <div className="text-center text-white">
        <Spinner size="lg" className="mb-4" />
        <h2 className="text-2xl font-bold mb-2">Microsoft認証処理中...</h2>
        <p className="text-lg opacity-75">しばらくお待ちください</p>
      </div>
    </div>
  );
};

export default MicrosoftCallbackPage; 